import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=7aabca9a"
import script from "./Delivery.vue?vue&type=script&lang=ts"
export * from "./Delivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports